import React, {Component} from 'react';
import moment from 'moment';
import {connect} from 'react-redux';
import ReactDataSheet from 'react-datasheet';
import {keyBy, merge, map, sortBy} from 'lodash';
import {Card, Select, Button} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {parseArrToGridExcel} from '../../utils/parseToArray';
import {montsSelect} from '../../../common/constants/months';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import Loader from '../../../common/components/loader';
import './styles.scss';
 
const YEARS = [{'key': 0, 'value': 2019, 'text': '2019'}];
const COLUMN_NORMAL = 1;
const COLUMN_EXONERED = 2;
const COLUMN_TOTAL = 3;

class WholeSalePlanned extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'year': moment().year(),
      'month': moment().month(),
      'grid': [],
    };
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.WholeSalePlanned, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    const {year, month} = this.state;
    this.props.getWholeSalePlanned(year, month);
    this.props.fetchVehiclesModel();
  }

  componentDidUpdate(prevProps) {
    const {data} = this.props;
    if (prevProps.data !== data) {
      this.setState({
        'grid': parseArrToGridExcel(data),
      });
    }
  }

  handleSearch = () => {
    const {year, month} = this.state;
    this.props.getWholeSalePlanned(year, month);
    this.setState({
      'grid': parseArrToGridExcel(this.props.data),
    });
  }

  handleSelect = (event, {name, value}) => {
    this.setState({[name]: value});
  };

  handleSave = () => {
    const {grid, year, month} = this.state;
    const {vehiclesByName} = this.props;

    const result = grid.slice(1, grid.length).map((item) => {
      const id = vehiclesByName[item[0].value].id;
      return ({
        year,
        month,
        'normal': item[COLUMN_NORMAL].value,
        'exonerated': item[COLUMN_EXONERED].value,
        'idFamily': id,
      });
    });

    this.props.saveWholeSalePlanned({'list': result}, year, month);
  }
 
  handleCellsChange = (changes) => {
    const grid = this.state.grid.map((row) => [...row]);
    changes.forEach(({cell, row, col, value}) => {
      grid[row][col] = {
        ...grid[row][col],
        'value': parseFloat(value) >= 0 ? parseFloat(value) : 0,
      };
      grid[row][COLUMN_TOTAL] = {
        ...grid[row][col],
        'value':
          parseFloat(grid[row][COLUMN_NORMAL].value) +
          parseFloat(grid[row][COLUMN_EXONERED].value),
        'readOnly': true,
      };
    });
    this.setState({grid});
  }

  render() {
    const {year, month, grid} = this.state;
    const validateSearch = !year || !month;
    return (
      <div>
        <Card raised fluid>
          <div className='wholesp-header'>
            <h2>Facturación Whole Planeada</h2>
            <div className='wholesp-header__controls'>
              <Select
                className='mr-2'
                placeholder='Selección de mes'
                name='month'
                options={montsSelect}
                defaultValue={month}
                onChange={this.handleSelect}
              />
              <Select
                className='mr-2'
                placeholder='Selección del año'
                options={YEARS}
                name='year'
                defaultValue={year}
                onChange={this.handleSelect}
              />
              <Button
                className='mr-3'
                disabled={validateSearch}
                onClick={this.handleSearch}
                color='black'
              >
                Consultar
              </Button>
              <Button onClick={this.handleSave} className='ml-3' color='green'>
                Guardar
              </Button>
            </div>
          </div>
        </Card>

        <Card raised fluid>
          <div className='wholesp-container'>
            {this.props.loadingWholeSale ? (
              <div className='wholesp__loader'>
                <Loader />{' '}
              </div>
            ) : (
              <ReactDataSheet
                valueRenderer={(cell) => cell.value}
                data={grid}
                onCellsChanged={(changes) => this.handleCellsChange(changes)}
              />
            )}
          </div>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const vehicles = sortBy(keyBy(state.vehiclesModels.vehicles, 'id'), 'idx');
  const vehiclesByName = keyBy(state.vehiclesModels.vehicles, 'name');
  const wholeSale = keyBy(state.wholeSalePlanned.wholeSalePlanned, 'id');
  const vehiclesWholeSale = map(vehicles, (item) => merge(wholeSale[item.id], item));

  return {
    'permissions': state.session.permissions,
    'loadingVehicles': state.vehiclesModels.loading,
    'data': vehiclesWholeSale,
    'loadingWholeSale': state.wholeSalePlanned.loading,
    vehiclesByName,
  };
};

const {fetchVehiclesModel, getWholeSalePlanned, saveWholeSalePlanned, navigateTo} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  fetchVehiclesModel,
  getWholeSalePlanned,
  saveWholeSalePlanned,
})(WholeSalePlanned);
